export const formatWordObj = (word, wordType = "", def = "") => ({
  words: [word],
  wordType,
  def
});
